import classNames from "classnames";
import Color from "color";
import { Typography } from "PFComponents/typography";
import React, { useMemo } from "react";

import { CalendarMode } from "../../../types";
import { WorkforceCalendarData } from "../context/booking_overview_context.types";
import { useBookingsOverviewContext } from "../context/bookings_overview_context";
import { useUtilizationDataProvider } from "../workforce_metrics";
import css from "./utilization.modules.scss";

interface UtilizationProps {
  value: number;
}

export const Utilization = ({ value }: UtilizationProps) => {
  const { calendarData, calendarMode } = useBookingsOverviewContext();
  const thresholds =
    calendarMode === CalendarMode.Workforce
      ? (calendarData as WorkforceCalendarData).thresholds?.utilization
      : [];
  const { getBackgroundColor } = useUtilizationDataProvider();
  const utilizationPercentage = useMemo(() => Math.round((value || 0) * 100), [value]);
  const utilizationColor = useMemo(() => {
    const colorCode = getBackgroundColor(utilizationPercentage / 100, thresholds);
    return colorCode && new Color(colorCode);
  }, [utilizationPercentage, thresholds]);

  return (
    <div
      className={classNames(css.utilization, {
        [css.dark]: utilizationColor && utilizationColor.isDark()
      })}
      style={{ ...(utilizationColor && { backgroundColor: utilizationColor.hex() }) }}
    >
      <Typography variant="labelRegular" noMargin>{`${utilizationPercentage}%`}</Typography>
    </div>
  );
};
